import React from "react"

import { Box } from "@mui/material"

import {
	ErrorResponse,
	Loading,
	RestResponse,
} from "@sinossi/mates-react-library"

import {SessionResponse} from "models"
import withUseRouter, { UseRouterParams } from "services/router"
import { AuthenticationService } from "services/authentication.service"
import {SessionService} from "services/session.service"
import Routes from "routes"
import { Header } from "structure"
import {MatesComponent, MatesComponentState} from "components/mates-component"

interface AppProps extends UseRouterParams
{
}
interface AppState extends MatesComponentState
{
	sessionData: SessionResponse | null
	authenticated: boolean
	authenticationError: boolean
}

class App extends React.Component<AppProps, AppState>
{
	// private keycloak?: Keycloak = undefined
	private authenticationService: AuthenticationService = AuthenticationService.init()
	private readonly matesComponent: MatesComponent<AppProps, AppState> = new MatesComponent(this)

	constructor(props: AppProps) {
		super(props);
		this.state = {
			...this.matesComponent.setupState(),
			sessionData: null,
			authenticated: false,
			authenticationError: false,
		}
	}


	public componentDidMount()
	{
		this.authenticationService.setupAuthentication()
			.then(this.getSession)
			.catch(() => {
				this.setState(
					() => ({
						authenticated: false,
						authenticationError: true,
					}),
					() => {
						let { navigate } = this.props
						navigate("/keycloak-error")
					}
				)
			})
	}

	private getSession = () => {
		SessionService.getSession(this.getSessionCallback, this.onError)
	}

	private getSessionCallback = (response: RestResponse<SessionResponse, ErrorResponse>) => {
		if(response.hasError()) {
			return
		}

		this.setState(
			() => ({
				sessionData: response.data,
				authenticated: true,
				authenticationError: false,
			}), () => localStorage.setItem("hideResearchMessage", String(response.data!.accountDetails.account.hideResearchInfo))
		)
	}

	private onError = (response: RestResponse<any, ErrorResponse>): void => {
		this.setState(
			() => ({
				authenticated: false,
				authenticationError: true,
			}),
			() => { this.matesComponent.onException(response) }
		)
	}

	public render()
    {
        return (
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					height: '100vh'
				}}
			>
				{this.state.sessionData &&
					<Box maxWidth="100%" height="100vh" sx={{display: "flex"}}>
						<Header sessionData={this.state.sessionData} />
						<Box component="main"
							 sx={{
								 overflow: "auto",
								 width: { xs: "100%", xl: "calc(100% - 260px)", },
								 height: "calc(100vh - 64px)",
								 mt: "64px",
							 }}>
							<Box sx={{bgcolor: "#E6EEFF", px: 5, pb: 10, minHeight: "100%", }}>
								{(this.state.authenticated || this.state.authenticationError) && <Routes sessionData={this.state.sessionData!} />}
								{(!this.state.authenticated && !this.state.authenticationError) && <Loading show={true} />}
							</Box>
						</Box>
					</Box>
				}
			</Box>
        )
    }
}

export default withUseRouter(App)
